module.exports = {"330881001":"双塔街道","330881002":"虎山街道","330881003":"清湖街道","330881102":"四都镇","330881105":"坛石镇","330881106":"大桥镇","330881109":"新塘边镇","330881112":"廿八都镇","330881113":"长台镇","330881116":"上余镇","330881118":"凤林镇","330881119":"峡口镇","330881120":"石门镇","330881121":"贺村镇","330881201":"大陈乡","330881203":"碗窑乡","330881207":"保安乡","330881213":"塘源口乡","330881214":"张村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330881.json
// module id = 1011
// module chunks = 0